export default __webpack_public_path__ + "static/media/diamond-360.fabe7fdd.svg";